import { handleActions } from 'redux-actions'
import { List } from 'immutable'
import { combineReducers } from 'redux-immutable'
import * as actions from './actions'

const savedReplies = handleActions({
  [actions.fetchSavedRepliesSuccess]: (state, action) => {
    return action.payload
  }
}, List())

const composerTextToInsert = handleActions({
  [actions.setComposerTextToInsert]: (state, action) => {
    return action.payload
  },
  [actions.clearComposerTextToInsert]: () => {
    return null
  }
}, null)


export default combineReducers({
  savedReplies,
  composerTextToInsert
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/composer/reducer.js